import UserRoleDetailsContainer from "./UserRoleDetailsContainer";

export default UserRoleDetailsContainer;
